import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Header } from '../../Header';
import { Footer } from '../../legacy/Footer';
import { SupportedBrowsersOnly } from '../../SupportedBrowsersOnly';
import { NoScript } from '../../NoScript';
import type { ContentUserT } from '../../../state/user';

interface Props {
  headerElement?: React.ReactNode;
  footerElement?: React.ReactNode;
  fullHeight?: boolean;
  children: React.ReactNode;
  user: ContentUserT;
}

/**
 * @deprecated This component is deprecated and will be removed in a future release.
 *
 * Page layout component that provides full page structure with header and footer.
 *
 * @remarks
 * This component is no longer maintained and may be removed in future releases.
 * Please migrate to alternative page layout solutions from the design system.
 *
 * @param user - Content user object for header personalization
 * @param fullHeight - Whether the page should take full viewport height (defaults to true)
 * @param headerElement - Custom header element (defaults to standard Header)
 * @param footerElement - Custom footer element (defaults to standard Footer)
 * @param children - Page content to be rendered in the main section
 *
 * @returns A complete page layout with header, main content, and footer
 *
 * @warning
 * Do not use this component in new code. It will be deleted in the future.
 */
export function Page({
  user,
  fullHeight = true,
  headerElement = <Header user={user} />,
  footerElement = <Footer />,
  children,
}: Props) {
  return (
    <SupportedBrowsersOnly>
      <NoScript />
      {fullHeight ? (
        <Box
          minHeight="100vh"
          flexDirection="column"
          alignItems="stretch"
          justifyContent="stretch"
        >
          {headerElement}
          <Box
            as="main"
            flex="1"
            flexDirection="column"
            alignItems="stretch"
            justifyContent="stretch"
          >
            {children}
          </Box>
          {footerElement}
        </Box>
      ) : (
        <>
          {headerElement}
          <main>{children}</main>
          {footerElement}
        </>
      )}
    </SupportedBrowsersOnly>
  );
}
